export var isIE = function () {
    // eslint-disable-next-line no-undef
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf('MSIE ');
    // If Internet Explorer
    // eslint-disable-next-line no-useless-escape,no-undef
    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
        return true;
    }
    return false;
};
